import React, { useEffect } from 'react';

/**
 * This page is the final callback of the IDaaS MFA flow - it will read the
 * verification result from the URL and send a message to the originating page
 * to allow the MFA Prompt to continue.
 */
export default function IdaasCallback(): JSX.Element {
  useEffect(() => {
    const bc = new BroadcastChannel('channel:nav/mfa-prompt/idaas');

    bc.postMessage({
      isSuccess: true,
    });
    bc.close();

    if (process.env.NODE_ENV !== 'test') {
      window.close();
    }
  }, []);

  return <>Please wait...</>;
}
